import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

type BadgeProps = {
  className?: string;
  children?: ReactNode;
  as?: 'span' | 'div';
  size: 'sm' | 'md' | 'lg';
  type: 'neutral' | 'positive' | 'negative' | 'attention' | 'prominence';
};

const sizeMap = {
  sm: 'w-[8px] h-[8px]',
  md: 'w-[16px] h-[16px]',
  lg: 'w-[20px] h-[20px]',
};

const typeMap = {
  neutral: 'bg-neutral-300 text-neutral-800',
  positive: 'bg-positive-500 text-neutral-0',
  negative: 'bg-negative-500 text-neutral-0',
  attention: 'bg-attention-500 text-neutral-0',
  prominence: 'bg-prominence-500 text-neutral-0',
};

export const Badge: FC<BadgeProps> = ({
  className,
  as: Element = 'div',
  children,
  size,
  type = 'neutral',
  ...rest
}) => {
  return (
    <Element
      {...rest}
      className={cn(
        'flex items-center justify-center rounded-full',
        sizeMap[size],
        typeMap[type],
        className,
      )}
    >
      {children}
    </Element>
  );
};
